import React from 'react';
import { useTranslation } from 'react-i18next';

interface MeetingStatusProps {
  started: boolean;
  isAdmin: boolean;
  onToggle?: () => void;
}

export const MeetingStatusPill = ({ started, isAdmin, onToggle }: MeetingStatusProps) => {
  const { t } = useTranslation();
  const baseClass = `inline-flex items-center gap-[6px] px-[12px] py-[5px] rounded-[32px] font-body text-[13px] font-semibold transition-all ${
    started
      ? 'bg-green-500 text-green-900 border border-green-900/30 animate-pulseBorder'
      : 'bg-[#DFDFE2] text-[#58585C] border border-[rgba(0,0,0,0.10)] dark:bg-[#3A3A3D] dark:text-[#A0A0A3] dark:border-[rgba(255,255,255,0.1)]'
  }`;

  const content = (
    <>
      <span
        className={`w-[8px] h-[8px] rounded-full flex-shrink-0 ${
          started ? 'bg-green-900 animate-pulseStrong' : 'bg-[#97979B] dark:bg-[#6B6B6F]'
        }`}
      />
      {started ? t('meetingStatus.inProgress') : t('meetingStatus.waiting')}
    </>
  );

  if (isAdmin && onToggle) {
    return (
      <button
        type="button"
        onClick={onToggle}
        className={`${baseClass} cursor-pointer ${
          started
            ? 'hover:shadow-[0_0_0_2px_#BFBFC0]'
            : 'hover:bg-[#E0E0E3] hover:shadow-[0_0_0_2px_rgba(34,197,94,0.6)]'
        }`}
      >
        {content}
      </button>
    );
  }

  return <span className={baseClass}>{content}</span>;
};
